export default {
  data() {
    return {
      inFavorites: false,
      isAddFavoritesLoading: false,
    };
  },

  created() {
    if(document.getElementById('check-favorites')) {
      this.$on('selected-product', this.checkFavorite);
    }
  },

  methods: {
    async addFavorite(e) {
      this.isAddFavoritesLoading = true;

      await this.$http.post('/account/favorite/' + document.querySelector('[name="sku[0]"]:checked').value)
        .then(response => this.inFavorites = true)
        .catch(error => {

          window.console.error(error.response, error.response.data);

        })
        .finally(() => this.isAddFavoritesLoading = false);
    },

    async checkFavorite() {
      this.isAddFavoritesLoading = true;

      await this.$http.get('/account/favorites/check/' + this.$refs.product.selected.sku)
        .catch(error => {

          window.console.error(error.response);

        })
        .then(response => this.inFavorites = (response.data.in_list === true))
        .finally(() => this.isAddFavoritesLoading = false);
    },

    async removeFavorite(sku) {
      return await this.$http.delete('/account/favorite/' + sku)
        .catch(error => {

          window.console.error(error.response, error.response.data);

        });
    },

    removeFormFavorite(e, callback) {
      this.isAddFavoritesLoading = true;

      const sku = document.querySelector('[name="sku[0]"]:checked').value;

      this.removeFavorite(sku)
        .then(response => this.inFavorites = false)
        .finally(() => this.isAddFavoritesLoading = false);
    },

    toggleFavorite(e, inFavorites) {
      if(inFavorites === true) {
        this.removeFormFavorite(e);

        return;
      }

      this.addFavorite(e);
    },
  },
}
